declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { BillDetailsInfoController, x_BillDetailsRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, X_BillHeaderController2, X_BillItemsController2, X_BillReceiptsController2, BillDetailsInfoController2 } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../models/api_response_model';
import { SpinnerService } from '../../../services/spinner.service';
//import { billingpipe } from '../../../pipes/actors/actorIdentity.pipes';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
import { BillingPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentModeChangeModal } from './modal/paymentmodechange.modal';
import { NgbServiceTrackingModal } from './modal/servicetracking.modal';



@Component({
  selector: 'billverfication',
  templateUrl: './billverfication.component.html',
  styleUrls: [
    './billverfication.component.scss']
  , animations: [routerTransition()]
})

export class BillVerficationComponent implements OnInit {



  public ApiResData: ApiResponseModel;
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public SelectedFormattedCode: string;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public billdetails1: boolean = false;
  public ChargeEntryCode: number;
  public billdetails2: boolean = false;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  public searchValue: string;
  public DiscountMode: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  SelectedFromDate: NgbDateStruct;
  CurrentBillDetailsInfoController: X_BillHeaderController2[];
  CurrentBillDetailsInfoControllernew: X_BillHeaderController2[];
  SelectedBillType: X_BillHeaderController[];
  Currentx_BillDetailsRequest: x_BillDetailsRequest;

  LoadForms() {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentBillDetailsInfoController;
    this.GetBillDetailsInfoController();
  }
  public SelectedReport: string;

  GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date();
    this.Currentx_BillDetailsRequest.ToDate = new Date();
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 20;
    this.Currentx_BillDetailsRequest.BillType = 'OPBILL';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    this.Currentx_BillDetailsRequest.SearchText = '';

    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController2(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    public printService: PrintService,
    private modalService: NgbModal,
    private actorservice: ActorService,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private parserFormatter: NgbDateParserFormatter,
    private filter: BillingPipe

    ,
  ) { }

  ngOnInit() {
    this.DiscountMode = AppData.Instance().GetDataParam('Discount Mode');
    //this.DiscountMode = 'Bill Level';
    this.LoadForms();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    // this.pdata = this.CurrentBillDetailsInfoController;
    }
    ClearInput2() {
        this.searchValue = '';
        this.billdetails1 = false;
        this.billdetails2 = false;
        this.CurrentBillDetailsInfoControllernew.length = 0;
        // this.searchValue = null;
        //var searchtext = '';
        //this._GetBillDetailsInfoController2(this.searchValue);
    }

    criteriaChange2(value: string) {
        this._GetBillDetailsInfoController2(value);
        // if (this.filter != null) {
        //if (value != '[object Event]') {
        //  this.listFilter = value;
        //  //alert(this.listFilter);
        //  this.pdata = this.filter.transform(this.CurrentResourceIdentificationByDateInfoController,
        //    this.listFilter);
        //}

    }
    _GetBillDetailsInfoController2(value:string) {
        this.StartRefreshing();
        //this.spinner.show();
        this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
        this.Currentx_BillDetailsRequest.FromDate = new Date();
        this.Currentx_BillDetailsRequest.ToDate = new Date();
        this.Currentx_BillDetailsRequest.ChargeEntry = 0;
        this.Currentx_BillDetailsRequest.ConditionalOperator = 20;
        this.Currentx_BillDetailsRequest.BillType = 'OPBILL';
        this.Currentx_BillDetailsRequest.FormattedCode = '';
        this.Currentx_BillDetailsRequest.SearchText = value;

        //alert(this.FormattedCode);
        this.actorservice.GetBillDetailsInfoController2(this.Currentx_BillDetailsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentBillDetailsInfoController = this.ApiResData.Result;
                    this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
                        function (a) {
                            return a.BillType != 'RXBILL';
                        });
                    this.pdata = this.CurrentBillDetailsInfoControllernew;
                    this.SelectedBillType = this.CurrentBillDetailsInfoController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
                    //this.spinner.hide();
                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  ShowList: boolean = true;



  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  AddNewBill() {

    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })

    modalRef.result.then((val: string) => {


      this.router.navigate(['healins/receipt', { Formattedcodedata: val }]);
      modalRef.componentInstance.FormattedCode = val;
      // this.SelectedFormattedCode = val;

      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    });
  }
  ViewPatientDetails() {
    this.router.navigate(['healins/billview']);
  }
  CancelNewOperation() {

    this.ShowList = true;
  }
  SelectedpatientDetails: X_BillHeaderController;
  Selectedpatient(objCategory: any) {
    var patient: X_BillHeaderController = objCategory;
    if (patient != null) {
      //alert(patient.ChargeEntry);
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = patient;

      this.billdetails1 = true;
      this.billdetails2 = true;
      this.LoadBillHeader();
      this.LoadBillItems();
      this.LoadBillReceipts();
    }


  }
  //Selectedpatient(l: BillDetailsInfoController) {
  //    var chargedentry = l.Header.ChargeEntry;
  //    alert(chargedentry);
  //}
  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController2(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.ChargeEntryCode = this.CurrentX_BillHeaderController[0].ChargeEntry;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentX_BillItemsController: X_BillItemsController2[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController2;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    //this.StartRefreshing();

    this.CurrentX_BillItemsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillItemsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillItemsController2(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillData = this.ApiResData.Result;
          this.CurrentX_BillItemsController = this.BillData.Items;
          this.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillReceiptsController: X_BillReceiptsController2[];

  CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

  BillDataReceipt: BillDetailsInfoController;

  LoadBillReceipts() {
    //alert("ScansData")
    this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillReceiptsController();
  }

  GetX_BillReceiptsController() {
    //this.StartRefreshing();

    this.CurrentX_BillReceiptsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillReceiptsController2(this.CurrentX_BillReceiptsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillDataReceipt = this.ApiResData.Result;
          this.CurrentX_BillReceiptsController = this.BillDataReceipt ? this.BillDataReceipt.Receipts : undefined;
          if (this.CurrentX_BillReceiptsController && this.CurrentX_BillReceiptsController.length > 0) {
            this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
            this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
            this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
            this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;
          }



          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  dataChanged(newobj) {

    this._GetBillDetailsInfoController()
  }
  _GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetBillDetailsInfoController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetBillDetailsInfoController();
    //ind++;
  }
  EditReceipt(l: X_BillReceiptsController) {

    const modalRef = this.modalService.open(NgbPaymentModeChangeModal,
      {
        centered: true

      })
    modalRef.componentInstance.Receiptno = l.FormattedCode;
    modalRef.componentInstance.CompanyRe = l.CompanyReceiptCode;
    modalRef.componentInstance.Billno = l.BillFormattedCode;
    modalRef.componentInstance.PatientName = l.PatientName;
    modalRef.componentInstance.ReceiptDate = l.ReceiptDate;
    modalRef.componentInstance.PaymentInstructions = l.PaymentInstrument;
    modalRef.componentInstance.PatientAccountReceiptDetailCode = l.PatientAccountReceiptDetailCode;
    modalRef.result.then(x => { this.GetX_BillReceiptsController() })

  }
  Addopbill() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    modalRef.result.then((val: string) => {
      if (val != 'Cross click') {
        this.router.navigate(['healins/receiptold', { FormattedCode: val }]);
      }
    });
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //criteriaChange(value: any) {
  //    if (this.filter != null) {
  //        if (value != '[object Event]') {
  //            this.listFilter = value;
  //            //alert(this.listFilter);
  //            this.pdata = this.filter.transform(this.CurrentBillDetailsInfoController,
  //                this.listFilter);
  //        }
  //    }
  //}

  //criteriaChange(value:string) {
  //    //alert(event);
  //    this.Refreshpatients(value);
  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentBillDetailsInfoControllernew;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentBillDetailsInfoControllernew,
          this.listFilter);
      }
    }
  }

  Refreshpatients(st: string) {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    this.Currentx_BillDetailsRequest.SearchText = st;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 20;
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    // this.pdata = this.CurrentBillDetailsInfoController;
    this._GetBillDetailsInfoControllerSearch();
  }
  _GetBillDetailsInfoControllerSearch() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    //this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          //this.pdata = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
    }
    servicetracking(l: X_BillItemsController) {
        const modalRef = this.modalService.open(NgbServiceTrackingModal,
            {
                centered: true

            })
       
        modalRef.componentInstance.Billno = l.BillNo;
        modalRef.componentInstance.PatientName = this.SelectedpatientDetails.PatientName;
        modalRef.componentInstance.Age = this.SelectedpatientDetails.PatientAgeY;
        modalRef.componentInstance.Gender = this.SelectedpatientDetails.PatientGender;
        modalRef.componentInstance.BillDate = this.SelectedpatientDetails.BillDate;
        modalRef.componentInstance.Branch = l.BranchName;
        modalRef.componentInstance.ItemName = l.ItemDescription;
        modalRef.componentInstance.Unitprice = l.UnitPrice;
        modalRef.componentInstance.Patientimage = this.SelectedpatientDetails.PatientImageFile;
        modalRef.componentInstance.ChargeEntryCode = l.ChargeEntry;
        modalRef.componentInstance.ChargeItemCode = l.ChargeItemCode;
        modalRef.componentInstance.Showunitprice = true;
        modalRef.result.then(x => { this.GetX_BillItemsController() })
    }
  header() {
    let m = document.querySelector("#header");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  billedit() {
    //alert("hello2");
    this.router.navigate(['healins/receiptedit', { FormattedCodedata: this.SelectedpatientDetails.PatientFormattedCode, ChargeEntryCode: this.ChargeEntryCode, BillStatus: this.CurrentX_BillHeaderController.BillStatus }]);
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    this.Refreshpatients(this.searchValue);
  }
  //opbill() {
  //  if (this.CurrentX_BillItemsController != null) {
  //    if (this.CurrentX_BillItemsController.length > 4) {
  //      this.printService.printDocument("opbill",
  //        {
  //          ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
  //          Branch: this.SelectedpatientDetails.BranchName, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

  //        },

  //      );
  //    }
  //    else {
  //      this.A5opbill();
  //    }
  //  }
  //}
  opbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  ipadvbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  opadvbill() {
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  rxbill() {
    //alert("hello");
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("pharmacybill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5opbill() { // a5 print
    //alert("hello");
    this.printService.printDocument("A5opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5ipadvbill() {
    //alert("hello");
    this.printService.printDocument("A5advrcpt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5opadvbill() {
    //alert("hello");
    this.printService.printDocument("A5advrcpt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5rxbill() {
    //alert("hello");
    this.printService.printDocument("A5rxbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
}
